import {Component, DestroyRef, Input, QueryList, ViewChildren} from '@angular/core';
import {NgClass} from '@angular/common';
import {ControlContainer, FormsModule, NgForm, NgModel} from '@angular/forms';
import {NlrHasPermissionsPipe} from '../../../common/pipe/nlr-has-permissions.pipe';
import {NlrPermissionsDisabledPipe} from '../../../common/pipe/nlr-permissions-disabled-pipe';
import {Tenure} from '../../../common/models/tenure-model';
import {NlrPatternDirective} from '../../../common/directive/nlr-pattern.directive';
import {NlrFormFieldHasErrorPipe} from '../../../common/pipe/nlr-form-field-has-error.pipe';
import {NgEventBus} from 'ng-event-bus';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';

@Component({
    selector: 'nlr-tenure-parent-plan-number',
    imports: [NgClass, FormsModule, NlrHasPermissionsPipe, NlrPermissionsDisabledPipe, NlrPatternDirective, NlrFormFieldHasErrorPipe],
    templateUrl: './tenure-parent-plan-number.component.html',
    styleUrl: './tenure-parent-plan-number.component.scss',
    viewProviders: [{provide: ControlContainer, useExisting: NgForm}]
})
export class TenureParentPlanNumberComponent {
    @Input() tenure: Tenure;
    @Input() label: string;
    @Input() submitted: boolean;
    @Input() readonly: boolean;
    @Input() name: string;
    planPattern = /^\d{1,8}$/;

    @ViewChildren(NgModel) inputModels!: QueryList<NgModel>;

    constructor(
        private eventBus: NgEventBus,
        private destroyRef: DestroyRef
    ) {}

    markAllInputsAsUntouched() {
        this.inputModels.forEach(model => {
            model.control.markAsUntouched();
            model.control.markAsPristine();
        });
    }

    ngOnInit() {
        this.eventBus
            .on('add-new-tenure')
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(() => {
                this.markAllInputsAsUntouched();
            });
    }
}
